export const ROUTES = {
  HOME: "/",
  REPORTS: "/reports",
  SETTINGS: "/settings",
  COLLECTIONSSITES: "/collection-sites",
  COLLECTION: "/collection",
  SPECIMENGALLERY: "/gallery",
  SPECIMEN: "/specimen"
};
